module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft--dark-4f9114f91f38737988345ce9c4c50dad.png";